module.exports = __webpack_public_path__ + "static/media/fff_about.a642d9ea.png";